// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20ZrG","delete":"styles_delete__13_Ck","update":"styles_update__2e6bz","add":"styles_add__3Rvag"};